// page-terms.jsx — 利用規約

(function(){
  const { HBLayout, HBSubHero, hbcp, fontEN, fontENSans, fontJP, fontMono, HB_BASE } = window;

  const SECTIONS = [
    { num:'01', t:'適用',
      d:'本規約は、はてなベース株式会社（以下「当社」）が提供する一切のサービス（以下「本サービス」）の利用条件を定めるものです。利用者（以下「ユーザー」）は本規約に同意のうえ、本サービスを利用するものとします。' },
    { num:'02', t:'利用登録',
      d:'本サービスの利用にあたり登録が必要な場合、ユーザーは正確な情報を当社に提供するものとします。当社は登録の可否を判断し、登録を承認した時点で利用契約が成立します。' },
    { num:'03', t:'禁止事項',
      d:'法令違反、犯罪行為、当社・第三者の知的財産権・プライバシー・名誉・信用を侵害する行為、サーバー等への過度な負荷、本サービスの運営を妨害する行為、その他当社が不適切と判断する行為を禁止します。' },
    { num:'04', t:'本サービスの提供の停止等',
      d:'当社は、保守点検・天災・通信回線の障害・その他の事由により、本サービスの全部または一部の提供を停止または中断することがあります。' },
    { num:'05', t:'免責事項',
      d:'当社は、本サービスに関して、その有用性・正確性・確実性・有効性・特定目的への適合性等につき、いかなる保証も行いません。当社の故意または重過失による場合を除き、損害賠償責任を負いません。' },
    { num:'06', t:'規約の変更',
      d:'当社は、必要と判断した場合に本規約を変更できるものとします。変更後の規約は、当社ウェブサイトに掲載した時点で効力を生じます。' },
    { num:'07', t:'準拠法・裁判管轄',
      d:'本規約の解釈は日本法に準拠します。本サービスに関して紛争が生じた場合、東京地方裁判所を第一審の専属的合意管轄裁判所とします。' },
  ];

  function TermsPage() {
    return (
      <HBLayout>
        <HBSubHero
          crumb={`Other / 利用規約`}
          en="Terms of Service"
          jp="利用規約"
          tag={'Last updated: 2025-04'}
          lead={'本規約は、当社が提供する各種サービスをご利用いただく際の基本的な取り決めです。サービス毎の個別規約・プライバシーポリシーと併せてご確認ください。'}
        />

        <section style={{padding:'72px 32px 96px', background:hbcp.white}}>
          <div style={{maxWidth:880, margin:'0 auto'}}>
            {SECTIONS.map(s => (
              <article key={s.num} style={{padding:'28px 0', borderTop:`1px solid ${hbcp.line}`}}>
                <div style={{display:'flex', gap:18, alignItems:'baseline', marginBottom:10}}>
                  <span style={{fontFamily:fontEN, fontWeight:300, fontSize:24, color:hbcp.blue, lineHeight:1, minWidth:36}}>{s.num}</span>
                  <h3 style={{fontFamily:fontJP, fontWeight:700, fontSize:20, lineHeight:1.4, margin:0}}>{s.t}</h3>
                </div>
                <p style={{fontSize:14, lineHeight:1.95, color:hbcp.inkSoft, margin:'0 0 0 54px'}}>{s.d}</p>
              </article>
            ))}
            <div style={{marginTop:48, padding:'28px', background:hbcp.paper, fontFamily:fontMono, fontSize:12, lineHeight:1.95, color:hbcp.inkSoft}}>
              はてなベース株式会社<br/>
              〒160-0005 東京都新宿区愛住町23-1 woody21 6階<br/>
              MAIL info@hatenabase.com / TEL 03-4500-2647
            </div>
          </div>
        </section>
      </HBLayout>
    );
  }

  Object.assign(window, { TermsPage });
})();
